
import { Alert, Space, Tabs} from 'antd';

import SpotlightedTopic from '../components/Topics/SpotlightedTopic';
import useFetchListData from '../hooks/useFetchListData';
import SpotlightedTopicMedias from '../components/Topics/SpotlightedTopicMedia';

export default function SpotlightedTopicPage() {
    const spotlightedParams = {type: 'topics', spotlighted: true, useDefaultParams: true};
	const spotlightedTopic = useFetchListData({params: spotlightedParams, newFunctions: true});

    const spotlightedKey = spotlightedTopic?.data?.[0]?.key || null;

    const items = [
        {
            key: '1',
            label: 'SPOTLIGHTED TOPIC',
            children: <SpotlightedTopic spotlightedTopic={spotlightedTopic} />,
            destroyInactiveTabPane: true,
        },
        {
            key: '2',
            label: 'SPOTLIGHTED MEDIA',
            children: spotlightedKey ? <SpotlightedTopicMedias topicKey={spotlightedKey} /> :
            <Alert
                description={
                        <><b>Please select a topic to be spotlighted. </b><br></br> When the spotlighted topic is selected, the list of media that are associated with it, will be enabled for their selection.</>}
                type="info"
                style={{marginBottom: 20}}
            />,
            destroyInactiveTabPane: true,
        },
    ];

	return (
		<>
			<Space size="large" direction='vertical' style={{width: '100%'}} >
				<h1>{`Homepage > Spotlighted Topic`}</h1>
			</Space>
            <Tabs defaultActiveKey="1" items={items} type="card" size="large"/>
		</>
	);
}